import { render, staticRenderFns } from "./selectPurchase.vue?vue&type=template&id=bf97094a&"
import script from "./selectPurchase.vue?vue&type=script&lang=js&"
export * from "./selectPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports